import React, { useState } from 'react';
import { Upload, Input, Button, Space, message } from 'antd';
import { UploadOutlined, LinkOutlined } from '@ant-design/icons';
import { uploadImageCDN } from '../utils/utility';

/**
 * UploadFileLink - cho phép upload file lên CDN HOẶC nhập link trực tiếp.
 * Upload xong tự điền URL vào Form field. Dùng cho file bất kỳ (không chỉ ảnh).
 *
 * Props (từ Form.Item):
 * - value: string (URL hiện tại)
 * - onChange: function (callback từ Form.Item)
 * - placeholder: string
 * - accept: string (mime/ext filter, mặc định mọi file)
 * - maxSizeMB: number (giới hạn dung lượng, mặc định 20MB)
 * - uploadFolder: string (namespace thư mục trên CDN, mặc định 'lichviet')
 */
const UploadFileLink = ({
  value,
  onChange,
  placeholder = 'Nhập link hoặc bấm Upload',
  accept = '*',
  maxSizeMB = 20,
  uploadFolder = 'lichviet',
}) => {
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (file) => {
    if (maxSizeMB && file.size / 1024 / 1024 > maxSizeMB) {
      message.error(`Dung lượng file phải nhỏ hơn ${maxSizeMB}MB!`);
      return Upload.LIST_IGNORE;
    }
    try {
      setUploading(true);
      const url = await uploadImageCDN(file, () => {}, uploadFolder);
      if (url) {
        onChange?.(url);
        message.success('Upload thành công!');
      } else {
        message.error('Upload thất bại!');
      }
    } catch {
      message.error('Lỗi khi upload file!');
    } finally {
      setUploading(false);
    }
    return false; // Ngăn antd tự upload
  };

  return (
    <Space.Compact style={{ width: '100%' }}>
      <Input
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        prefix={<LinkOutlined style={{ color: '#999' }} />}
        allowClear
      />
      <Upload showUploadList={false} beforeUpload={handleUpload} accept={accept} maxCount={1}>
        <Button icon={<UploadOutlined />} loading={uploading} type="primary" ghost>
          Upload
        </Button>
      </Upload>
    </Space.Compact>
  );
};

export default UploadFileLink;
